module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_kurva_1.9f9b734b.jpg";